<template>
    <div>
        <div v-if="authenticated !== false">
            <div v-if="confirmed === true">
                <p>Your account has been confirmed.</p>
            </div>
            <div v-else-if="confirmed === false">
                <p>There was a problem confirming your account.</p>
            </div>
            <div v-else-if="!this.$route.query.code">
                <p>You need to click or copy and paste the link from the email into your browser.</p>
            </div>
            <div v-else>
                <p>Confirming...</p>
            </div>
        </div>
        <div v-else>
            <p>You are not logged in.</p>
        </div>
        <router-link to="/dashboard">
            Dashboard
        </router-link>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters('user', [
            'authenticated',
            'confirmed'
        ])
    },
    mounted() {
        this.checkAuthentication({
            requiresAuth: true,
            enforceRedirect: false
        })
            .then((result) => {
                if (result && this.$route.query.code) {
                    this.confirm(this.$route.query.code);
                }
                else if (this.$route.query.code) {
                    this.$router.push({ name: 'Login', query: { redirect: this.$route.fullPath } });
                }
            });
    },
    methods: {
        ...mapActions('user', [
            'checkAuthentication',
            'confirm',
            'login',
            'logout'
        ])
    }
};
</script>

<style lang="scss">

</style>
